import * as React from 'react';
import icon from '../../assets/img/flags/wyoming.svg';

export const Wyoming = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
